// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../../uikit/atoms/Icon/IconV5.bs.js");
let Tooltip = require("../../../reason/common/Tooltip.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../ErrorHandling/UnselectedUnionMemberError.bs.js");
let UseShouldShowPropertyDetails = require("../Hooks/UseShouldShowPropertyDetails.bs.js");
let AgentPropertyLocation_property_graphql = require("../../../__generated__/AgentPropertyLocation_property_graphql.bs.js");
let AgentPropertyLocation_propertyLocation_graphql = require("../../../__generated__/AgentPropertyLocation_propertyLocation_graphql.bs.js");

let convertFragment = AgentPropertyLocation_property_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentPropertyLocation_property_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentPropertyLocation_property_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, AgentPropertyLocation_property_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(AgentPropertyLocation_property_graphql.node, convertFragment, fRef);
}

let PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = AgentPropertyLocation_propertyLocation_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, AgentPropertyLocation_propertyLocation_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(AgentPropertyLocation_propertyLocation_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, AgentPropertyLocation_propertyLocation_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(AgentPropertyLocation_propertyLocation_graphql.node, convertFragment$1, fRef);
}

let PropertyLocationFragment_visibilityReason_decode = AgentPropertyLocation_propertyLocation_graphql.Utils.visibilityReason_decode;

let PropertyLocationFragment_visibilityReason_fromString = AgentPropertyLocation_propertyLocation_graphql.Utils.visibilityReason_fromString;

let PropertyLocationFragment = {
  visibilityReason_decode: PropertyLocationFragment_visibilityReason_decode,
  visibilityReason_fromString: PropertyLocationFragment_visibilityReason_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function AgentPropertyLocation$Address(props) {
  let visibilityRule = props.visibilityRule;
  let locationDisplay = props.locationDisplay;
  let address = props.address;
  let tmp;
  if (address !== undefined) {
    let exit = 0;
    if (visibilityRule !== undefined) {
      let exit$1 = 0;
      if (visibilityRule === "VISIBLE_TO_ACCOUNT_MEMBER" || visibilityRule === "VISIBLE_TO_TAN_STAFF" || visibilityRule === "VISIBLE_TO_ALL") {
        switch (visibilityRule) {
          case "VISIBLE_TO_ALL" :
            exit = 1;
            break;
          case "VISIBLE_TO_ACCOUNT_MEMBER" :
          case "VISIBLE_TO_TAN_STAFF" :
            exit$1 = 2;
            break;
        }
      } else {
        exit = 1;
      }
      if (exit$1 === 2) {
        let tmp$1;
        if (visibilityRule === "VISIBLE_TO_ACCOUNT_MEMBER" || visibilityRule === "VISIBLE_TO_TAN_STAFF" || visibilityRule === "VISIBLE_TO_ALL") {
          switch (visibilityRule) {
            case "VISIBLE_TO_ACCOUNT_MEMBER" :
              tmp$1 = " (only visible to you)";
              break;
            case "VISIBLE_TO_ALL" :
              tmp$1 = "";
              break;
            case "VISIBLE_TO_TAN_STAFF" :
              tmp$1 = " (visible to TAN staff)";
              break;
          }
        } else {
          tmp$1 = "";
        }
        tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx("div", {
              children: locationDisplay
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(IconV5.make, {
                    icon: "lock",
                    size: 16,
                    className: "text-gray-600 mr-1"
                  }),
                  JsxRuntime.jsx(Tooltip.make, {
                    label: address + tmp$1,
                    children: JsxRuntime.jsx("div", {
                      children: "Hidden Address",
                      className: "border-dotted border-b border-gray-400"
                    })
                  })
                ],
                className: "flex flex-row items-center lg:before:content-['('] lg:after:content-[')'] before:content-none after:content-none"
              }),
              className: "text-gray-600 text-lg"
            })
          ]
        });
      }
    } else {
      exit = 1;
    }
    if (exit === 1) {
      tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsx("div", {
            children: address
          }),
          JsxRuntime.jsx("div", {
            children: locationDisplay,
            className: "text-gray-600 text-lg"
          })
        ]
      });
    }
  } else {
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx("div", {
          children: locationDisplay
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(IconV5.make, {
                icon: "lock",
                size: 16,
                className: "text-gray-600 mr-1"
              }),
              JsxRuntime.jsx("div", {
                children: "Hidden Address"
              })
            ],
            className: "flex flex-row items-center lg:before:content-['('] lg:after:content-[')'] before:content-none after:content-none"
          }),
          className: "text-gray-600 text-lg"
        })
      ]
    });
  }
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("div", {
      children: tmp,
      className: "flex flex-col gap-2 lg:gap-2 lg:flex-row items-baseline"
    }),
    className: "text-gray-700 font-medium text-2xl lg:text-3xl"
  });
}

let Address = {
  make: AgentPropertyLocation$Address
};

function AgentPropertyLocation$ProPlanLabel(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "bg-tan-gold text-white px-2 py-1 text-base rounded font-semibold"
  });
}

let ProPlanLabel = {
  make: AgentPropertyLocation$ProPlanLabel
};

function AgentPropertyLocation$AddressFreePlan(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: props.locationDisplay
        }),
        className: "text-gray-700 font-medium text-2xl lg:text-3xl"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: "Address",
            className: "text-zinc-500 tracking-wide  font-medium uppercase"
          }),
          JsxRuntime.jsx(AgentPropertyLocation$ProPlanLabel, {
            children: "Pro Plan Only"
          })
        ],
        className: "flex gap-1 flex-col items-baseline"
      })
    ],
    className: "flex flex-col gap-2"
  });
}

let AddressFreePlan = {
  make: AgentPropertyLocation$AddressFreePlan
};

function AgentPropertyLocation$ByPropertyLocation(props) {
  let propertyLocation = RescriptRelay_Fragment.useFragment(AgentPropertyLocation_propertyLocation_graphql.node, convertFragment$1, props.propertyLocation);
  if (props.shouldShowPropertyDetails) {
    switch (propertyLocation.__typename) {
      case "PropertyLocationWithHiddenAddress" :
        return JsxRuntime.jsx(AgentPropertyLocation$Address, {
          address: undefined,
          locationDisplay: propertyLocation.locationDisplay
        });
      case "PropertyLocationWithVisibleAddress" :
        return JsxRuntime.jsx(AgentPropertyLocation$Address, {
          address: propertyLocation.address,
          locationDisplay: propertyLocation.locationDisplay,
          visibilityRule: propertyLocation.visibilityRule
        });
      case "__unselected" :
        break;
    }
  } else {
    switch (propertyLocation.__typename) {
      case "PropertyLocationWithHiddenAddress" :
        return JsxRuntime.jsx(AgentPropertyLocation$AddressFreePlan, {
          locationDisplay: propertyLocation.locationDisplay
        });
      case "PropertyLocationWithVisibleAddress" :
        return JsxRuntime.jsx(AgentPropertyLocation$AddressFreePlan, {
          locationDisplay: propertyLocation.locationDisplay
        });
      case "__unselected" :
        break;
    }
  }
  return UnselectedUnionMemberError.raise(`Unselected property location ` + propertyLocation._0);
}

let ByPropertyLocation = {
  make: AgentPropertyLocation$ByPropertyLocation
};

function AgentPropertyLocation$ProjectAddressLine(props) {
  let propertyLocation = RescriptRelay_Fragment.useFragment(AgentPropertyLocation_propertyLocation_graphql.node, convertFragment$1, props.propertyLocation);
  let text;
  switch (propertyLocation.__typename) {
    case "PropertyLocationWithHiddenAddress" :
      text = propertyLocation.locationDisplay;
      break;
    case "PropertyLocationWithVisibleAddress" :
      text = propertyLocation.address + `, ` + propertyLocation.locationDisplay;
      break;
    case "__unselected" :
      text = "";
      break;
  }
  if (text === "") {
    return null;
  } else {
    return JsxRuntime.jsx("div", {
      children: text,
      className: "text-gray-600"
    });
  }
}

let ProjectAddressLine = {
  make: AgentPropertyLocation$ProjectAddressLine
};

function AgentPropertyLocation$WithoutErrorBoundary(props) {
  let property = RescriptRelay_Fragment.useFragment(AgentPropertyLocation_property_graphql.node, convertFragment, props.property);
  let shouldShowPropertyDetails = UseShouldShowPropertyDetails.use(property.fragmentRefs);
  return JsxRuntime.jsx(AgentPropertyLocation$ByPropertyLocation, {
    propertyLocation: property.propertyLocation.fragmentRefs,
    shouldShowPropertyDetails: shouldShowPropertyDetails
  });
}

let WithoutErrorBoundary = {
  make: AgentPropertyLocation$WithoutErrorBoundary
};

function AgentPropertyLocation(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "location",
    children: JsxRuntime.jsx(AgentPropertyLocation$WithoutErrorBoundary, {
      property: props.property
    })
  });
}

let make = AgentPropertyLocation;

exports.PropertyFragment = PropertyFragment;
exports.PropertyLocationFragment = PropertyLocationFragment;
exports.Address = Address;
exports.ProPlanLabel = ProPlanLabel;
exports.AddressFreePlan = AddressFreePlan;
exports.ByPropertyLocation = ByPropertyLocation;
exports.ProjectAddressLine = ProjectAddressLine;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* IconV5 Not a pure module */
